'use strict';

module.exports = {
  name: 'InstartLogic',
  refresh: function refresh() {
    return null;
  },

  pageTargetsScript: function pageTargetsScript() {
    return '//InstartLogic Page Targets\n    if (window.I11C != undefined && I11C.Morph == 1) { googletag.pubads().setTargeting(\'shield\', \'1\'); }';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvSW5zdGFydExvZ2ljRXh0ZW5zaW9uLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJuYW1lIiwicmVmcmVzaCIsInBhZ2VUYXJnZXRzU2NyaXB0Il0sIm1hcHBpbmdzIjoiOztBQUFBQSxPQUFPQyxPQUFQLEdBQWlCO0FBQ2ZDLFFBQU0sY0FEUztBQUVmQyxXQUFTLG1CQUFNO0FBQ2IsV0FBTyxJQUFQO0FBQ0QsR0FKYzs7QUFNZkMscUJBQW1CLDZCQUFNO0FBQ3ZCO0FBRUQ7QUFUYyxDQUFqQiIsImZpbGUiOiJJbnN0YXJ0TG9naWNFeHRlbnNpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cyA9IHtcbiAgbmFtZTogJ0luc3RhcnRMb2dpYycsXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfSxcblxuICBwYWdlVGFyZ2V0c1NjcmlwdDogKCkgPT4ge1xuICAgIHJldHVybiBgLy9JbnN0YXJ0TG9naWMgUGFnZSBUYXJnZXRzXG4gICAgaWYgKHdpbmRvdy5JMTFDICE9IHVuZGVmaW5lZCAmJiBJMTFDLk1vcnBoID09IDEpIHsgZ29vZ2xldGFnLnB1YmFkcygpLnNldFRhcmdldGluZygnc2hpZWxkJywgJzEnKTsgfWA7XG4gIH1cbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Extensions/InstartLogicExtension.js
// module id = 1517
// module chunks = 0